module.exports = __webpack_public_path__ + "img/serveLogo3.4028a532.png";